<template>
  <div class="skeleton-list">
    <ion-list lines="full" class="ion-no-padding">
      <ion-item color="primary">
        <ion-label text-wrap>
          <span class="h-f-b">
            <ion-skeleton-text animated></ion-skeleton-text>
          </span>
        </ion-label>
        <ion-note class="h-f-m" color="light" slot="end">
          <ion-skeleton-text animated></ion-skeleton-text>
        </ion-note>
      </ion-item>

      <ion-item v-for="i in 10" :key="i" lines="full">
        <ion-label>
          <ion-skeleton-text animated style="width:50%"></ion-skeleton-text>
        </ion-label>
        <div slot="end">
          <ion-skeleton-text animated></ion-skeleton-text>
        </div>
      </ion-item>
    </ion-list>
  </div>
</template>

<script>
export default {
  name: "skeleton-list"
};
</script>